class Accordion {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._accordionItems = this._elem.querySelectorAll('[data-accordion-item]')
    }

    onInit () {
        for (let accordionItem of this._accordionItems) {
            let accordionItemHeader = accordionItem.querySelector('[data-accordion-header]')
            let accordionItemContent = accordionItem.querySelector('[data-accordion-content]')

            accordionItemHeader.addEventListener('click', (e) => {
                e.preventDefault()
                if (accordionItem.hasAttribute('data-accordion-item-expanded')) {
                    accordionItem.classList.remove('open')
                    accordionItemContent.style.height = `0px`
                    accordionItem.removeAttribute('data-accordion-item-expanded')
                } else {
                    for (let otherItem of this._accordionItems) {
                        let itemContent = otherItem.querySelector('[data-accordion-content]')
                        otherItem.classList.remove('open')
                        itemContent.style.height = `0px`
                        otherItem.removeAttribute('data-accordion-item-expanded')
                    }

                    accordionItem.classList.add('open')
                    accordionItemContent.style.height = `${accordionItemContent.scrollHeight}px`
                    accordionItem.setAttribute('data-accordion-item-expanded', '')
                }
            })

            if (accordionItem.hasAttribute('data-accordion-item-expanded')) {
                accordionItem.classList.add('expanded')
                accordionItemContent.style.height = `${accordionItemContent.scrollHeight}px`
            }
        }
    }
}

export default Accordion



// WEBPACK FOOTER //
// ./src/scripts/components/Accordion.js